/* @flow */

import * as React from 'react';
import { useIntl } from 'react-intl';
import createUseThemeStyles from 'src/shared/app/base/util/createUseThemeStyles';

import styles from './SkipNavLink.style';

import messages from 'src/shared/app/nav/l10n/navigationL10n';
import { mainContentId } from 'src/shared/app/nav/settings/navSettings';

const useStyles = createUseThemeStyles(styles);

const SkipNavLink = (): React.Node => {
  /*
   |----------------------------------------------------------------------------
   | Hooks
   |----------------------------------------------------------------------------
   */

  const intl = useIntl();

  /*
   |----------------------------------------------------------------------------
   | Classes
   |----------------------------------------------------------------------------
   */

  const classes = useStyles();

  /*
   |----------------------------------------------------------------------------
   | Elements
   |----------------------------------------------------------------------------
   */

  return (
    <a className={classes.root} href={`#${mainContentId}`}>
      {intl.formatMessage(messages.skip)}
    </a>
  );
};

export default React.memo<{}>(SkipNavLink);
